var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video",style:({maxHeight:(_vm.maxHeight + "px")}),attrs:{"id":"welcome-video","poster":_vm.posterUrl,"playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.videoUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }